import {
  DELETE_TABLE_LIST_FAILURE, DELETE_TABLE_LIST_REQUEST, DELETE_TABLE_LIST_SUCCESS,
  GET_BYID_TABLE_LIST_FAILURE, GET_BYID_TABLE_LIST_REQUEST, GET_BYID_TABLE_LIST_SUCCESS,
  GET_TABLE_LIST_FAILURE, GET_TABLE_LIST_REQUEST, GET_TABLE_LIST_SUCCESS,
  POST_TABLE_LIST_FAILURE, POST_TABLE_LIST_REQUEST, POST_TABLE_LIST_SUCCESS,
  PUT_TABLE_LIST_FAILURE, PUT_TABLE_LIST_REQUEST, PUT_TABLE_LIST_SUCCESS,RESET_TABLE_FLAGS
} from "../../../Utils/Constant";

const initialState = {
  tablesList: [],
  addtable: {},
  tableList: {},
  loading: false,
  error: null,
  addSuccess: false,
  editSuccess: false,
  deleteSuccess: false,
};


export const tableReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TABLE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_TABLE_LIST_SUCCESS:
      return {
        ...state,
        tablesList: action.payload,
        loading: false,
        error: null,
      };
    case GET_TABLE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // POST amenity
    case POST_TABLE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_TABLE_LIST_SUCCESS:
      return {
        ...state,
        addtable: action.payload,
        addSuccess: true,
        loading: false,
        error: null,
      };
    case POST_TABLE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        addSuccess: false,
        error: action.payload,
      };

    // DELETE amenity
    case DELETE_TABLE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_TABLE_LIST_SUCCESS:
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
        error: null,
      };
    case DELETE_TABLE_LIST_FAILURE:
      return {
        ...state,
        deleteSuccess: false,
        loading: false,
        error: action.payload,
      };

    case PUT_TABLE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PUT_TABLE_LIST_SUCCESS:
      return {
        ...state,
        editSuccess: true,
        loading: false,
        error: null,
      };
    case PUT_TABLE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        editSuccess: false,
        error: action.payload,
      };

    case GET_BYID_TABLE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_BYID_TABLE_LIST_SUCCESS:
      return {
        ...state,
        tableList: action.payload,
        loading: false,
        error: null,
      };
    case GET_BYID_TABLE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case RESET_TABLE_FLAGS:
        return {
          ...state,
          addSuccess: false,
          editSuccess: false,
          deleteSuccess: false,
        };
    default:
      return state;
  }
};
